<template>
  <google-2fa-code-form
    v-model="code"
    :title="tr('Disable Google 2FA')"
    :is-loading="isSaving"
    destructive
    @submit="() => confirm()"
    @cancel="() => cancel()"
  />
</template>

<script>
import AuthService from '@/services/Auth';
import Google2faCodeForm from '@/ui/components/Google2faCodeForm.vue';

export default {
  name: 'DisableGoogle2fa',
  components: {
    Google2faCodeForm,
  },
  data: () => ({
    isSaving: false,
    code: '',
  }),
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      if (this.code.length !== 6) {
        this.error(this.tr('You must enter the 6-digit code from the Google Authenticator app.'));
        return;
      }

      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      AuthService.disableGoogle2fa(this.code)
        .then(resp => {
          this.$root.loggedInUser.google_2fa_enabled = false;
          this.$toast.success(this.tr('Two-factor authentication has been successfully disabled.'));
          this.$emit('success');

          return resp;
        })
        .catch(err => this.error(err))
        .finally(() => this.isSaving = false);
    },
  },
};
</script>
